import { Badge } from '@fukuri-admins/ui/common';
import { match } from 'ts-pattern';

type Status =
  | 'invalid_csv'
  | 'registered'
  | 'csv_uploaded'
  | 'completed'
  | 'completed_with_errors'
  | 'processing'
  | 'cancelled';

type Props = {
  status: Status;
};

export const StatusBadge: React.FC<Props> = ({ status }) =>
  match(status)
    .with('invalid_csv', () => <Badge status='negative' variant='subtle' label='失敗' size='sm' />)
    .with('registered', () => <Badge status='info' variant='subtle' label='予約中' size='sm' />)
    .with('csv_uploaded', () => (
      <Badge status='neutral' variant='subtle' label='準備中' size='sm' />
    ))
    .with('completed', () => <Badge status='success' variant='subtle' label='完了' size='sm' />)
    .with('completed_with_errors', () => (
      <Badge status='negative' variant='subtle' label='一部失敗' size='sm' />
    ))
    .with('processing', () => <Badge status='neutral' variant='subtle' label='処理中' size='sm' />)
    .with('cancelled', () => <Badge status='neutral' variant='subtle' label='取り消し' size='sm' />)
    .exhaustive();
